import styled from 'styled-components'

export const StepperWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
`

export const StepContainer = styled.div`
  display: flex;
  align-items: center;
`

export const StepCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${({ $shape }) => ($shape === 'rounded' ? '8px' : '50%')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  background: ${({ $active, $completed }) =>
    $completed ? 'var(--color-brand)' :
    $active ? 'var(--color-brand)' :
    'var(--vo-cloud)'};
  color: ${({ $active, $completed }) =>
    $completed ? 'white' :
    $active ? 'white' :
    'var(--vo-slate)'};
  border: ${({ $active }) =>
    $active ? `2px solid var(--color-brand)` : 'none'};
`

export const StepLabel = styled.span`
  margin: 0 8px;
  font-size: 14px;
  font-weight: ${({ $active, $completed }) =>
    $active || $completed ? '600' : '400'};
  color: ${({ $active, $completed }) =>
    $completed ? 'var(--color-brand)' :
    $active ? 'var(--vo-ink)' :
    'var(--vo-slate)'};
  white-space: nowrap;
`

export const StepConnector = styled.div`
  width: 40px;
  height: 2px;
  background: ${({ $completed }) =>
    $completed ? 'var(--color-brand)' : 'var(--vo-cloud)'};
  margin: 0 4px;
`
